import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { fetchSysPublicBranding } from '@/api/sysBranding'

const envTitle = import.meta.env.VITE_APP_TITLE ?? '贵州省境外安全保护预警和应急指挥系统'

export const useSysBrandingStore = defineStore('sysBranding', () => {
  const systemName = ref(envTitle)
  const systemDescription = ref(
    '为境外黔籍人员提供全方位安全保护服务，实时监控境外安全态势，快速响应应急事件',
  )
  const systemLogo = ref('')
  const copyrightText = ref('')
  const loaded = ref(false)

  const logoUrlOrDefault = computed(() => {
    const u = systemLogo.value?.trim()
    return u || '/image/国徽.png'
  })

  const logoUrlOrFavicon = computed(() => {
    const u = systemLogo.value?.trim()
    return u || '/favicon.ico'
  })

  function fallbackCopyright(): string {
    const y = new Date().getFullYear()
    return `©${y} 贵州省外事办公室 版权所有`
  }

  async function loadPublic(force = false) {
    if (loaded.value && !force) return
    try {
      const d = await fetchSysPublicBranding()
      if (d.systemName?.trim()) systemName.value = d.systemName.trim()
      if (d.systemDescription != null && String(d.systemDescription).trim() !== '') {
        systemDescription.value = String(d.systemDescription).trim()
      }
      systemLogo.value = d.systemLogo?.trim() ?? ''
      copyrightText.value = d.copyrightText?.trim() || fallbackCopyright()
    } catch {
      copyrightText.value = fallbackCopyright()
    } finally {
      loaded.value = true
    }
  }

  return {
    systemName,
    systemDescription,
    systemLogo,
    copyrightText,
    loaded,
    logoUrlOrDefault,
    logoUrlOrFavicon,
    loadPublic,
  }
})
